(() => {
  const originalFetch = window.fetch;

  // Cache addon ids at submit time so the fetch interceptor has them
  // even when document.activeElement no longer points to the form on mobile.
  let _lastSubmittedForm = null;
  let _lastAddonIds = [];

  function captureAddons() {
    document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
      if (form.__addonHooked) return;
      form.__addonHooked = true;
      form.addEventListener(
        "submit",
        () => {
          _lastSubmittedForm = form;
          const fid = form.getAttribute("id");
          _lastAddonIds = fid
            ? Array.from(
                document.querySelectorAll(
                  `input[name="addon_variant_ids[]"][form="${CSS.escape(fid)}"]:checked`
                )
              )
                .map((el) => parseInt(el.value || "", 10))
                .filter((n) => Number.isFinite(n))
            : [];
        },
        { capture: true }
      );
    });
  }

  document.addEventListener("DOMContentLoaded", captureAddons);
  document.addEventListener("shopify:section:load", captureAddons);
  if (document.readyState !== "loading") captureAddons();

  function isCartAdd(url) {
    try {
      const u = typeof url === "string" ? url : (url && url.url) || "";
      return u.includes("/cart/add");
    } catch {
      return false;
    }
  }

  function getActiveForm(body) {
    const el = document.activeElement;
    const inside = el && el.closest ? el.closest("form") : null;
    if (inside) return inside;

    // Sticky bar / detached submit buttons reference their form via the `form` attribute
    if (el && el.getAttribute) {
      const fid = el.getAttribute("form");
      if (fid) {
        const f = document.getElementById(fid);
        if (f) return f;
      }
    }

    // Fall back to matching the section-id from the request body to the product form
    let sectionId = null;
    if (body instanceof FormData) {
      sectionId = body.get("section-id");
    } else if (typeof body === "string") {
      try { sectionId = JSON.parse(body)["section-id"]; } catch {}
    }
    if (sectionId) {
      const f = document.querySelector(`form[id*="${CSS.escape(sectionId)}"][action="/cart/add"]`);
      if (f) return f;
    }
    return document.querySelector('form[action="/cart/add"]');
  }

  function getQtyFromForm(form) {
    const qtyInput =
      form.querySelector('input[name="quantity"]') ||
      form.querySelector('.quantity-selector__input[name="quantity"]') ||
      form.querySelector('quantity-input input[name="quantity"]');

    const qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getMainVariantIdFromBody(body) {
    if (body instanceof FormData) {
      const id = parseInt(body.get("id") || "", 10);
      return Number.isFinite(id) ? id : null;
    }
    if (typeof body === "string") {
      try {
        const obj = JSON.parse(body);
        const id = parseInt(obj.id || "", 10);
        return Number.isFinite(id) ? id : null;
      } catch {}
    }
    return null;
  }

  function getAddonIdsForForm(form) {
    const fid = form.getAttribute("id");
    if (!fid) return [];
    return Array.from(
      document.querySelectorAll(
        `input[name="addon_variant_ids[]"][form="${CSS.escape(fid)}"]:checked`
      )
    )
      .map((el) => parseInt(el.value || "", 10))
      .filter((n) => Number.isFinite(n));
  }

  function openCartDrawer() {
    // Many themes open drawer via a button click
    const openers = [
      '[data-action="open-drawer"]',
      '[aria-controls="cart-drawer"]',
      '[aria-controls*="cart"]',
      'a[href="/cart"]',
      'a[href^="/cart"]'
    ];

    for (const sel of openers) {
      const el = document.querySelector(sel);
      if (el) {
        el.click();
        return;
      }
    }

    // Some themes use a <cart-drawer> custom element with an .open() method
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      drawer.open();
    }
  }

  function notifyCartUpdated() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
    document.dispatchEvent(new CustomEvent("cart:updated"));
    document.dispatchEvent(new CustomEvent("cart:change"));
  }

  window.fetch = async function (input, init = {}) {
    if (!isCartAdd(input)) return originalFetch(input, init);

    const method = (init.method || "GET").toUpperCase();
    if (method !== "POST") return originalFetch(input, init);

    const form = _lastSubmittedForm || getActiveForm(init.body);
    if (!form) return originalFetch(input, init);

    const addonIds = _lastAddonIds.length ? _lastAddonIds : getAddonIdsForForm(form);
    _lastSubmittedForm = null;
    _lastAddonIds = [];
    if (!addonIds.length) return originalFetch(input, init);

    const mainId = getMainVariantIdFromBody(init.body);
    if (!mainId) return originalFetch(input, init);

    const qty = getQtyFromForm(form);

    const items = [{ id: mainId, quantity: qty }];
    addonIds.forEach((id) => {
      if (id !== mainId) items.push({ id, quantity: 1 });
    });

    // IMPORTANT: preserve the original URL (including ?sections=...) so drawer refresh works
    const url = typeof input === "string" ? input : input.url;

    // Preserve original headers, but ensure JSON headers
    const headers = new Headers(init.headers || {});
    headers.set("Content-Type", "application/json");
    headers.set("Accept", "application/json");

    const newInit = {
      ...init,
      method: "POST",
      headers,
      body: JSON.stringify({ items })
    };

    const res = await originalFetch(url, newInit);

    // After success, refresh + open drawer (theme may also do it, but this guarantees it)
    if (res.ok) {
      notifyCartUpdated();
      openCartDrawer();
    }

    return res;
  };
})();
